import {FC, useState} from 'react'
import Register from "./register"
import s from './index.module.scss'
import Button from "../../common/button"

import imgHd from './images/hd.jpg'
import imgS from './images/s.jpg'
import imgM from './images/md.jpg'

import imgHdMembership from './images/hd-membership.jpg'
import imgMMembership from './images/md-membership.jpg'
import imgSMembership from './images/s-membership.jpg'

import imgHdFleet from './images/hd-fleet.jpg'
import imgMFleet from './images/md-fleet.jpg'
import imgSFleet from './images/s-fleet.jpg'

import imgHdPrivate from './images/hd-private.jpg'
import imgMPrivate from './images/md-private.jpg'
import imgSPrivate from './images/s-private.jpg'

import imgNYSFHd from './images/hd-nysf.jpg'
import imgNYSFM from './images/md-nysf.jpg'
import imgNYSFS from './images/s-nysf.jpg'

import imgNYASHd from './images/hd-nyas.jpg'
import imgNYASM from './images/md-nyas.jpg'
import imgNYASS from './images/s-nyas.jpg'

import imgCalHd from './images/cal.png'
import imgCalM from './images/cal-md.png'
import imgCalS from './images/cal-s.png'

import imgSFHamHd from './images/SF-Ham-HD.jpg'
import imgSFHamM from './images/SF-Ham-M.jpg'
import imgSFHamS from './images/SF-Ham-S.jpg'


import gogMd from './images/nysf-google-md.jpg'
import gogHd from './images/nysf-google-hd.jpg'
//arabic
import imgLAr from './images/arabic/home-ar-l.jpg'
import imgMAr from './images/arabic/home-ar-m.jpg'
import imgSAr from './images/arabic/home-ar-s.jpg'

import imgLArPrivate from './images/arabic/private-ar-l.jpg'
import imgMArPrivate from './images/arabic/private-ar-m.jpg'
import imgSArPrivate from './images/arabic/private-ar-s.jpg'

import imgLArFleet from './images/arabic/fleet-ar-l.jpg'
import imgMArFleet from './images/arabic/fleet-ar-m.jpg'
import imgSArFleet from './images/arabic/fleet-ar-s.jpg'

import imgLArMember from './images/arabic/member-ar-l.jpg'
import imgMArMember from './images/arabic/member-ar-m.jpg'
import imgSArMember from './images/arabic/member-ar-s.jpg'

import {getParamFromUrl} from "../../../utils/url";

type Props = {
  type: string
  renderForm: () => any
  isLoading: boolean
  content: string
  disclaimer: string
  isArabic?: boolean
}
const schema = {
  'FLYXOGGHOMEPAGE': [imgHd, imgM, imgS],
  'FLYXOFBHOMEPAGE': [imgHd, imgM, imgS],
  'FLYXOFBHOMEPAGEUK': [imgHd, imgM, imgS],
  'FLYXOFBHOMEPAGEMENA': [imgHd, imgM, imgS],
  'FLYXOFBHOMEPAGEEU': [imgHd, imgM, imgS],
  'FLYXOYHHOMEPAGE': [imgHd, imgM, imgS],
  'FLYXOBGHOMEPAGE': [imgHd, imgM, imgS],





  'SHELLBAYCLUB': [gogHd, gogMd, imgNYSFS],

  'MIAMIHERALD': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'NFT23': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'SHAREDEXPNYSFL': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'SHAREDEXPNYASP' : [imgNYASHd, imgNYASM, imgNYASS],
  'FLYXOTTSHAREDNYSFL': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'FLYXOGGSHAREDNYASP' : [imgNYASHd, imgNYASM, imgNYASS],
  'FLYXOFBSHAREDNYASP' : [imgNYASHd, imgNYASM, imgNYASS],
  'FLYXOTTSHAREDNYASP' : [imgNYASHd, imgNYASM, imgNYASS],
  'NYFLSEATS' :[imgNYSFHd, imgNYSFM, imgNYSFS],


  'ZOOMNEWYORK':[imgNYSFHd, imgNYSFM, imgNYSFS],
  'ZOOMFLORIDA':[imgNYSFHd, imgNYSFM, imgNYSFS],
  'FASHAREDNYFL':[imgNYSFHd, imgNYSFM, imgNYSFS],
  'NEWSDAY':[imgNYSFHd, imgNYSFM, imgNYSFS],
  'NYDAILYNEWS':[imgNYSFHd, imgNYSFM, imgNYSFS],
  'SEATS':[imgNYSFHd, imgNYSFM, imgNYSFS],
  'MAKEAWISH24':[imgNYSFHd, imgNYSFM, imgNYSFS],


  'FASHAREDASPEN': [imgNYASHd, imgNYASM, imgNYASS],


  'SUMMERIN23': [imgNYASHd, imgNYASM, imgNYASS],
  'FW23': [imgNYASHd, imgNYASM, imgNYASS],
  'ASPENTIMES23': [imgNYASHd, imgNYASM, imgNYASS],

  'ASPEN23BMG': [imgNYASHd, imgNYASM, imgNYASS],
  'SHAREDNYASP': [imgNYASHd, imgNYASM, imgNYASS],
  'BMGSHAREDNYASP': [imgNYASHd, imgNYASM, imgNYASS],
  'ZOOMASPEN': [imgNYASHd, imgNYASM, imgNYASS],
  'NYASPSEATS' : [imgNYASHd, imgNYASM, imgNYASS],

  'REALDEAL23': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'ZOOMHAMPTONS': [imgSFHamHd, imgSFHamM, imgSFHamS],
  'FLYXOGGSHAREDSFLHAMP': [imgSFHamHd, imgSFHamM, imgSFHamS],
  'FLYXOFBSHAREDSFLHAMP': [imgSFHamHd, imgSFHamM, imgSFHamS],

  'MGOLF23': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'WELCOMEMERCER': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'WELCOMEBOWERY': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'WELCOMECHELSEA': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'WELCOMEGREENWICH': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'EXEC': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'FLYXOTTSHARED': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'SHAREDEXP': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'LIFETIME': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'FLYXOGGMEMBERSHIPPAGE': [imgHdMembership, imgMMembership, imgSMembership],
  'FLYXOBGMEMBERSHIPPAGE': [imgHdMembership, imgMMembership, imgSMembership],
  'FLYXOYHMEMBERSHIPPAGE': [imgHdMembership, imgMMembership, imgSMembership],
  'FLYXOGGFLEETPAGE': [imgHdFleet, imgMFleet, imgSFleet],
  'FLYXOBGFLEETPAGE': [imgHdFleet, imgMFleet, imgSFleet],
  'FLYXOYHFLEETPAGE': [imgHdFleet, imgMFleet, imgSFleet],
  'FLYXOGGPRIVATEJETCOSTPAGE': [imgHdPrivate, imgMPrivate, imgSPrivate],
  'FLYXOBGPRIVATEJETCOSTPAGE': [imgHdPrivate, imgMPrivate, imgSPrivate],
  'FLYXOYHPRIVATEJETCOSTPAGE': [imgHdPrivate, imgMPrivate, imgSPrivate],
  'FLYXOGGHOMEPAGEUK': [imgHd, imgM, imgS],
  'FLYXOGGPRIVATEJETCOSTPAGEUK': [imgHdPrivate, imgMPrivate, imgSPrivate],
  'FLYXOGGFLEETPAGEUK': [imgHdFleet, imgMFleet, imgSFleet],
  'FLYXOGGMEMBERSHIPPAGEUK': [imgHdMembership, imgMMembership, imgSMembership],
  'FLYXOGGHOMEPAGEMENA': [imgHd, imgM, imgS],
  'FLYXOGGPRIVATEJETCOSTPAGEMENA': [imgHdPrivate, imgMPrivate, imgSPrivate],
  'FLYXOGGFLEETPAGEMENA': [imgHdFleet, imgMFleet, imgSFleet],
  'FLYXOGGMEMBERSHIPPAGEMENA': [imgHdMembership, imgMMembership, imgSMembership],
  'FLYXOGGSHAREDCALENDAR': [imgCalHd, imgCalM, imgCalS ],
  'FLYXOFBSHAREDCALENDAR': [imgCalHd, imgCalM, imgCalS ],
  'FLYXOBGPRIVATEJETCOSTPAGEUK': [imgHdPrivate, imgMPrivate, imgSPrivate],
  'FLYXOBGFLEETPAGEUK': [imgHdFleet, imgMFleet, imgSFleet],
  'FLYXOBGMEMBERSHIPPAGEUK': [imgHdMembership, imgMMembership, imgSMembership],
  'FLYXOBGHOMEPAGEUK': [imgHd, imgM, imgS],
  'FLYXOBGPRIVATEJETCOSTPAGMENA': [imgHdPrivate, imgMPrivate, imgSPrivate],
  'FLYXOBGFLEETPAGEMENA': [imgHdFleet, imgMFleet, imgSFleet],
  'FLYXOBGMEMBERSHIPPAGEMENA': [imgHdMembership, imgMMembership, imgSMembership],
  'FLYXOAPP': [imgHd, imgM, imgS],

  'FLYXOBGHOMEPAGEMENA': [imgHd, imgM, imgS],
  'FLYXOGGSHAREDMENA': [imgHd, imgM, imgS],
  'FLYXOBGSHAREDMENA': [imgHd, imgM, imgS],
  'FLYXOFBSHAREDMENA': [imgHd, imgM, imgS],
  'FLYXOOGHOMEPAGEUS': [imgHd, imgM, imgS],
  'FLYXOOGHOMEPAGEUK': [imgHd, imgM, imgS],
  'FLYXOOGHOMEPAGEMENA': [imgHd, imgM, imgS],
  'FLYXOLIHOMEPAGEUK': [imgHd, imgM, imgS],
  'FLYXOLIHOMEPAGEMENA': [imgHd, imgM, imgS],
  'BILLBOARD': [gogHd, gogMd, imgNYSFS],
  'GYM': [gogHd, gogMd, imgNYSFS],
  'BOAT':[gogHd, gogMd, imgNYSFS],
  'MALL': [gogHd, gogMd, imgNYSFS],
  'SBE':[gogHd, gogMd, imgNYSFS],
  'MARTINI':[gogHd, gogMd, imgNYSFS],

  'DMNYFLSEATS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'DMNYASPENSEATS': [imgNYASHd, imgNYASM, imgNYASS],
  'NYASPENSEATS': [imgNYASHd, imgNYASM, imgNYASS],
  'TVNYFLSEATS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'TVNYASPENSEATS': [imgNYASHd, imgNYASM, imgNYASS],
  'METS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'GIANTS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'JETS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'ISLANDERS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'RANGERS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'KNICKS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'PANTHERS': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'HEAT': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'POLICE': [imgNYSFHd, imgNYSFM, imgNYSFS],
  'ASPENTIMES24': [imgNYASHd, imgNYASM, imgNYASS],


  //arabic
  'FLYXOGGHOMEPAGEARG':  [imgLAr, imgMAr, imgSAr],
  'FLYXOFBHOMEPAGEUKARG': [imgLAr, imgMAr, imgSAr],
  'FLYXOFBHOMEPAGEARG': [imgLAr, imgMAr, imgSAr],
  'FLYXOBGHOMEPAGEARG': [imgLAr, imgMAr, imgSAr],

  'FLYXOGGPRIVATEJETCOSTPAGEARG': [imgLArPrivate, imgMArPrivate, imgSArPrivate],
  'FLYXOBGPRIVATEJETCOSTPAGARG': [imgLArPrivate, imgMArPrivate, imgSArPrivate],

  'FLYXOGGFLEETPAGEARG': [imgLArFleet, imgMArFleet, imgSArFleet],
  'FLYXOBGFLEETPAGEARG': [imgLArFleet, imgMArFleet, imgSArFleet],

  'FLYXOGGMEMBERSHIPPAGEARG': [imgLArMember, imgMArMember, imgSArMember],
  'FLYXOBGMEMBERSHIPPAGEARG': [imgLArMember, imgMArMember, imgSArMember],

}

const Shared: FC<Props> = ({type, isArabic, disclaimer, content, renderForm}) => {
  let code = getParamFromUrl('code')
  if (!code) {
    code = 'FLYXOGGHOMEPAGE'
  }
  if (type === 'ny-sf'){
    code = 'SHELLBAYCLUB'
  }
  if (type === 'home'){
    code = 'FLYXOGGHOMEPAGE'
  }

  const [isForm, setIsForm] = useState(false)
  return (
    <div className={isForm ? s.rootForm : s.root} style={isForm ? {backgroundImage: `url(${schema[code as keyof typeof schema][0]})`} : {}}>
      {isForm ? (
        <div className='homepage-banner'>
          <div className={s.form}>
            <Register renderForm={renderForm}/>
          </div>
        </div>
      ) : (
        <>
          {content ? (
            <div className={s.fixed}>
              <div className={s.beforeForm}>
                <div dangerouslySetInnerHTML={{__html: content}}/>
                <Button onClick={() => {
                  setIsForm(true)
                }}>{isArabic ? "تسجيل" : "Register Now"}</Button>
              </div>
            </div>) : null}
          <img alt='' className={s.hdImage} src={schema[code as keyof typeof schema][0]}/>
          <img alt='' className={s.mobileImage} src={schema[code as keyof typeof schema][2]}/>
          <img alt='' className={s.tabletImage} src={schema[code as keyof typeof schema][1]}/>
          {!disclaimer ? null : <div className={s.disclaimer} dangerouslySetInnerHTML={{__html: disclaimer}}/>}
        </>
      )}
    </div>
  )
}

export default Shared

